import { pxToRem, theme } from '@pocketlaw/tetris';
import styled from 'styled-components';
export const RootContainer = styled.div `
  display: flex;
  height: 100%;
`;
export const SidebarPanel = styled.div `
  width: 100%;
  min-width: ${pxToRem(300)};
  max-width: ${pxToRem(360)};
  border-right: solid ${pxToRem(1)} ${theme.semantic.border.default};
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
`;
export const ContentPanel = styled.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
`;
export const Header = styled.div `
  padding: ${theme.spacing.xl} ${theme.spacing['2xl']};
  flex-shrink: 0;
`;
export const Footer = styled.div `
  padding: ${theme.spacing['2xl']};
  flex-shrink: 0;
`;
export const Body = styled.div `
  padding: ${theme.spacing.md} ${theme.spacing['2xl']};
  flex: 1;
  overflow: auto;
`;
